import React from 'react';
import RegisterUser from '../../components/Register';
import AuthWrapper from '../../layout/auth/auth-wrapper';

const SignUp = () => {
  return (
    <AuthWrapper>
      <RegisterUser />
    </AuthWrapper>
  );
};

export default SignUp;
